import styled from 'styled-components';

export const RefundsInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;

  @media screen and (min-width: 1023px) {
    flex-direction: row;
  }

  .column {
    display: flex;

    &.icon {
      align-items: center;
      justify-content: center;
      padding: 8px;

      svg {
        height: 40px;
        width: 40px;
        color: #7b8794;
      }

      .big {
        display: none;
      }
      .small {
        display: block;
      }

      @media screen and (min-width: 1023px) {
        .big {
          display: block;
        }
        .small {
          display: none;
        }
      }
    }
  }

  .card-item {
    flex: 1;
  }
`;
